<template>
  <div class="flex items-center flex-wrap">
    <span class="bold topLabel caps col-12 my3 py2">{{ user.firstname }}, personnalisez votre commande</span>
    <span v-if="sessionDate" class="h5 bold caps col-12 px2 pb2">{{ sessionDate }}</span>
    <div v-for="(session, index) in sessions" :key="index" class="pointer white-bg col-12 py1 px2 my1 card-top border" :class="{'disabled': session.placesDisponibles <= 0}" @click="selectTerrain(index)">
      <div class="col-12 flex justify-between">
        <div class="col-10 flex flex-wrap justify-between">
          <div class="flex items-center col-12">
            <div class="flex bold h4 m0 p1">{{ session.nomActivite }}</div>
            <div v-for="image in session.activitiesPictos" :key="image" class="flex m0">
              <img
                :src="image"
                width="48"
                height="48"
              >
            </div>
          </div>
          <div v-if="session.activitiesInfo" class="flex col-12 m1 h6">
            {{ session.activitiesInfo }}
          </div>
        </div>
        <div v-if="session.placesDisponibles > 0" class="col-2 flex justify-center items-center">
          <span :class="['custom-radio flex ', { 'selected-item': isSelectedTerrain(index) }]"></span>
        </div>
        <div v-else class="col-2 flex justify-center items-center">
          <span>COMPLET</span>
        </div>
      </div>
    </div>
    <div class="col-12 my3 py3 flex justify-end items-center">
      <Button class="col-3 sm-col-12 p1" :action="handleBack" :text="hasProducts ? 'Precedent' : 'Retour'" color="grey-bg" />
      <Button v-if="!loading" class="col-5" :action="confirmTerrain" text="Continuez" :disabled="selectedTerrainIndex === null" />
      <Button v-else class="col-4 sm-col-6 ml2" :disabled="true" icon="icon icon-loader" />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import Button from '@/components/elements/Button';
import { frenchTime, backToAlpha } from '@/utils/utils';
import { changeToPage, hasProductsStep } from '@/utils/logics';

const store = useStore();

const loading = ref(false);
const selectedTerrainIndex = ref(null);

const user = computed(() => store.state.user);
const siteInfo = computed(() => store.state.siteInfo);
const hasProducts = computed(() => hasProductsStep());

const sessions = computed(() => (store.state.sessions?.items || []).map(i => ({
  ...i,
  activitiesInfo: i.activities?.length && i.activities.some(a => a.tda_info)
    ? i.activities.reduce((acc, prev) => (acc === '' ? prev.tda_info : `${acc}; ${prev.tda_info}`), '')
    : null,
  activitiesPictos: i.activities?.length && (i.activities.some(a => a.tda_image) || i.activities.some(a => a.tdaImageSEO?.url))
    ? i.activities.reduce((acc, prev) => acc.concat(`https://media.ucpa.com/w_64,h_64/${prev.tdaImageSEO?.url ? prev.tdaImageSEO.url : prev.tda_image}`), [])
    : null
})));

const sessionDate = computed(() => {
  if (!sessions.value.length) return '';
  const first = sessions.value[0];
  return frenchTime(first.timestampDebutCreneau, 'EEE dd MMMM / HH:mm', siteInfo.value?.timezone)
    + frenchTime(first.timestampFinCreneau, ' - HH:mm', siteInfo.value?.timezone);
});

const selectTerrain = index => {
  selectedTerrainIndex.value = index;
};

const isSelectedTerrain = index => selectedTerrainIndex.value === index;

const handleBack = () => {
  if (hasProducts.value) {
    changeToPage('Products');
  } else {
    backToAlpha();
  }
};

const confirmTerrain = async () => {
  const { cartItem } = store.state;
  const session = sessions.value[selectedTerrainIndex.value];

  if (!session) return;

  cartItem.details.activities = session.activities;
  cartItem.session = {
    name: session.nomActivite,
    code: session.codeCreneau,
    start_time: session.timestampDebutCreneau,
    end_time: session.timestampFinCreneau,
    last_time: session.timestampDernierCreneau
  };
  store.commit('setCartItem', { ...cartItem });
  loading.value = true;
  changeToPage('AddParticipant');
};

onMounted(() => {
  if (sessions.value.length === 1) {
    selectedTerrainIndex.value = 0;
    confirmTerrain();
  }
});
</script>

<style lang="scss" scoped>
  .shadow {
    box-shadow: 0px 2px 5px 1px #ddd;
  }
  .line-height-0 {
    line-height: 0;
  }
</style>
